import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CanonicalService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    // Set it once immediately (useful for first render / hydration).
    this.updateCanonicalUrl();

    // Listen to route changes to update canonical URL
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCanonicalUrl();
      });
  }

  private updateCanonicalUrl(): void {
    // Remove any existing canonical tag
    const existingCanonicalTag = this.document.querySelector(
      'link[rel="canonical"]'
    );
    if (existingCanonicalTag) {
      existingCanonicalTag.remove();
    }

    // Create and add the new canonical tag
    const canonicalUrl = this.getCanonicalUrl();
    const link: HTMLLinkElement = this.document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", canonicalUrl);
    this.document.head.appendChild(link);
  }

  private getCanonicalUrl(): string {
    const base = environment.frontendUrl.replace(/\/$/, "");
    const path = this.router.url.split("?")[0]; // Remove query parameters
    return `${base}${path}`;
  }

  // Public method to force update canonical URL
  public setCanonical(): void {
    this.updateCanonicalUrl();
  }
}
